import React, { FC } from 'react';
import ErrorLoadingDetailProperty from 'components/shared/detail/ErrorLoadingDetailProperty';
import { Requirements } from 'types/Requirement';
import AccordionWidgetEmptyMessage from 'app/modules/posts/components/accordionWidget/AccordionWidgetEmptyMessage';
import Skeleton from 'react-loading-skeleton';

type Props = {
  isLoading?: boolean;
  isError?: boolean;
  requirements: Requirements;
  children: (r: Requirements) => JSX.Element[] | JSX.Element;
  scrollable?: boolean;
};

const PostRequirementsView: FC<Props> = ({
  isLoading,
  isError,
  requirements,
  children,
  scrollable = true,
}) => {
  return (
    <>
      {isLoading && <Skeleton height={60} />}
      {isError && <ErrorLoadingDetailProperty />}
      {requirements.length === 0 && !isLoading && !isError && (
        <AccordionWidgetEmptyMessage variant="postRequirements" />
      )}
      {!!requirements.length && !isError && !isLoading && (
        <div
          className={
            scrollable ? 'tw-relative tw-max-h-[30vh] tw-overflow-auto' : ''
          }
        >
          {children(requirements)}
        </div>
      )}
    </>
  );
};

export default PostRequirementsView;
